import { FieldName } from '../types/CardFieldName';
import { t } from './i18n';

const getFieldKey = (fieldName: FieldName): string => {
  switch (fieldName) {
    case FieldName.Number:
      return 'card.number';
    case FieldName.HolderName:
      return 'card.holderName';
    case FieldName.ExpireDate:
      return 'card.expireDate';
    case FieldName.CVV:
      return 'card.cvv';
    case FieldName.PostalCode:
      return 'card.postalCode';
  }
};

export const getFieldErrorMessage = ({
  fieldName,
  isFinished,
  isEmpty,
  i18nParams,
}: {
  fieldName: FieldName;
  isFinished: boolean;
  isEmpty: boolean;
  i18nParams?: Record<string, string>;
}): string => {
  switch (fieldName) {
    case FieldName.Number:
    case FieldName.ExpireDate:
    case FieldName.CVV:
      if (isEmpty) {
        return t(`${getFieldKey(fieldName)}.error.empty`, i18nParams);
      } else {
        return isFinished
          ? t(`${getFieldKey(fieldName)}.error`, i18nParams)
          : t(`${getFieldKey(fieldName)}.error.finish`, i18nParams);
      }
    case FieldName.HolderName:
      return t('card.holderName.error');
    case FieldName.PostalCode:
      return t('card.postalCode.error');
  }
};
